export class City {
  constructor(
    readonly id: string,
    readonly name: string,
    readonly timeZone: string,
    readonly countryCode: string,
    readonly regionId?: string,
  ) {}
}
